import React from "react";
import { Modal, View, StyleSheet, TouchableOpacity } from "react-native";
import CustomText from "../CustomText/CustomText";
import { X } from "@phosphor-icons/react/dist/csr/X";
import { shadowStyles } from "../../../../styles/shadow";

const CustomAdminModal = ({
  visible,
  onRequestClose,
  children,
  style,
  title = "",
  onShow = undefined,
  ariaLabel = "",
  ...props
}) => {
  return (
    <Modal
      id="custom-admin-modal"
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}
      onShow={onShow}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel ?? title}
      {...props}>
      <View style={styles.centeredView}>
        <View style={[styles.modalView, shadowStyles.modal, style]}>
          <View style={styles.header}>
            <CustomText role="heading" text={title} style={styles.titleText} useTranslationText={false} />
            <TouchableOpacity style={styles.closeButton} onPress={onRequestClose} aria-label="Close modal">
              <X size={16} weight="bold" color="#667085" />
            </TouchableOpacity>
          </View>
          <View style={styles.content}>{children}</View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalView: {
    borderRadius: 16,
    backgroundColor: "#ffffff",
    overflow: "hidden",
    width: "90%",
    maxWidth: 600,
    maxHeight: "90%",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 24,
    backgroundColor: "#F2F4F7",
  },
  titleText: {
    fontSize: 20,
    fontWeight: "600",
    color: "#101828",
  },
  closeButton: {
    padding: 4,
  },
  content: {
    backgroundColor: "#ffffff",
    flex: 1,
  },
});

export default CustomAdminModal;
